<template>
	<ContractListOnline :courtierId="tiers.tiers_id" />
</template>

<script type="text/javascript">
	export default {
		name: "ContractTiersCourtierOnline",
		props: ['tiers'],
		components: {
			ContractListOnline: () => import('@/components/Contract/ContractListOnline')
		}
	}
</script>
